import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoDav: CultureInfo = {
  name: 'dav',
  displayName: 'Kitaita',
  iso3LanguageCode: 'dav',
  iso2LanguageCode: 'dav',
  ietfLanguageTag: 'dav',
  parent: null
};
